import { z } from '@hono/zod-openapi'

// 権限アクション
export const PERMISSION_ACTIONS = [
  'create',
  'read',
  'update',
  'delete',
] as const
export type PermissionAction = (typeof PERMISSION_ACTIONS)[number]

// 画面識別子
export const SCREEN_IDS = [
  'login', // ログイン
  'admin_users', // アカウント管理
  'properties', // 物件情報管理
  'rooms', // 部屋情報管理（/properties/:id/rooms配下）
  'owners', // オーナー管理
  'tenants', // 賃借人管理（レポート出力機能含む）
  'tenant_applicants', // 新規入居者申込
  'notifications', // お知らせ管理
  'tickets', // 案件管理
  'payments', // お支払い管理
  'roles', // ロール管理
  'organizations', // 組織管理
  'user_profile', // ユーザー情報編集
] as const

export type ScreenId = (typeof SCREEN_IDS)[number]

// Zod スキーマ
export const screenIdZ = z.enum(SCREEN_IDS)
export const permissionActionZ = z.enum(PERMISSION_ACTIONS)
